import cleanUpResponse from "@/util/cleanUpResponse";

export default async function GetDeliveryScheduleImportByOrderId(orderId, commandId) {
    const response = await $.soap({
        body: {
            GetDeliveryScheduleImportByOrderId: {
                $xmlns: 'http://dla.mil/ems/bpm/order/delivery_schedule_import',
                OrderId: orderId,
                CommandId: commandId
            }
        },
        blueprintArrays: [
          'GetDeliveryScheduleImportByOrderIdResponse.DeliveryScheduleImports.DeliveryScheduleImport',
          'GetDeliveryScheduleImportByOrderIdResponse.DeliveryScheduleImports.DeliveryScheduleImport.Errors.DeliveryScheduleImportError'
        ],
        blueprint: {
            files: [
                'GetDeliveryScheduleImportByOrderIdResponse.DeliveryScheduleImports.DeliveryScheduleImport',
                {
                    id: '$..ID',
                    orderId: '$..OrderID',
                    fileName: '$..FileName',
                    createdBy: '$..CreatedBy',
                    dateCreated: '$..DateCreated',
                    status: '$..Status',
                    errors: [
                      '$.Errors.DeliveryScheduleImportError',
                      {
                        id: '$..ID',
                        deliveryScheduleImportId: '$..DeliveryScheduleImportID',
                        description: '$..Description',
                        rowNumber: '$..RowNumber',
                        columnNumber: '$..ColumnNumber'
                      }
                    ]
                }
            ]
        }
    });
    cleanUpResponse(response);
    return response.files;
}